import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-background">
      <div className="soft-card max-w-xl w-full text-center">
        <p className="inline-flex items-center rounded-full bg-blue-100/80 px-3 py-1 text-sm font-medium text-blue-700 dark:bg-blue-950/40 dark:text-blue-300 mb-4">Error 404</p>
        <h1 className="section-heading mb-4">Page not found</h1>
        <p className="section-subtitle mb-6">The page you were looking for does not exist or has been moved.</p>
        <a href="/" className="inline-flex items-center justify-center rounded-full bg-blue-600 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-700">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
